import React from 'react'

import {Grid, GridProps} from '../../grid'
import {css} from '../../theme/css'

const className = css`
  color: #121212;
  opacity: 0.5;
`

const GridHeader: React.FC<React.PropsWithChildren<GridProps>> = props => {
  return <Grid className={className} {...props} />
}

export default GridHeader
